import Configuration from './root.vue'
import MainNav from './main_nav.vue'
import shopInfo from './shop_info/router'
import cashierConfig from './cashier_config/router'
import ticketPrinting from './ticket_printing/router'

const route = {
    path: 'configuration',
    component: Configuration,
    children: [{
        path: '',
        redirect: 'nav'
    }, {
        path: 'nav',
        component: MainNav,
        children: [{
            path: '',
            redirect: 'shopInfo'
        },
            shopInfo,
            cashierConfig,
            ticketPrinting
        ]
    }]
}

export default route
